var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('img',{staticClass:"icon",attrs:{"src":_vm.img}}):(_vm.html)?_c('span',{class:'icon icon-' + _vm.cls,style:({ background: _vm.bg }),domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }